
import React, { useState } from 'react';
import { 
  Card, 
  CardContent,
} from "@/components/ui/card";
import { 
  Tabs, 
  TabsContent, 
  TabsList, 
  TabsTrigger 
} from "@/components/ui/tabs";
import { 
  TrendingUp, 
  Zap, 
  Users, 
  Target, 
  Music, 
  MessageSquare, 
  Share 
} from 'lucide-react';

import ViralContentGenerator from './ai-suite/ViralContentGenerator';
import AutoPromoCampaigns from './ai-suite/AutoPromoCampaigns';
import FanEngagementManager from './ai-suite/FanEngagementManager';
import AIAdManager from './ai-suite/AIAdManager';
import PlaylistPitching from './ai-suite/PlaylistPitching';
import ContentGenerator from './ai-suite/ContentGenerator';
import ContentReshaper from './ai-suite/ContentReshaper';

const AIMarketingSuite: React.FC = () => {
  const [activeTab, setActiveTab] = useState("viral-content");

  return (
    <div className="space-y-6">
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-purple-500/20 to-violet-500/20 blur-2xl -z-10 rounded-3xl"></div>
        <Card className="border-0 shadow-xl bg-background/70 backdrop-blur-sm overflow-hidden">
          <CardContent className="p-0">
            <Tabs 
              defaultValue="viral-content" 
              value={activeTab}
              onValueChange={setActiveTab}
              className="w-full"
            >
              <TabsList className="grid grid-cols-7 bg-muted/50 p-1 rounded-none border-b overflow-x-auto h-auto flex-wrap">
                <TabsTrigger value="viral-content" className="data-[state=active]:bg-background rounded-none py-3">
                  <div className="flex items-center gap-2">
                    <TrendingUp className="h-4 w-4" />
                    <span className="hidden md:inline">Viral Content</span>
                  </div>
                </TabsTrigger>
                <TabsTrigger value="auto-promo" className="data-[state=active]:bg-background rounded-none py-3">
                  <div className="flex items-center gap-2">
                    <Zap className="h-4 w-4" />
                    <span className="hidden md:inline">Auto-Promo</span>
                  </div>
                </TabsTrigger>
                <TabsTrigger value="fan-engagement" className="data-[state=active]:bg-background rounded-none py-3">
                  <div className="flex items-center gap-2">
                    <Users className="h-4 w-4" />
                    <span className="hidden md:inline">Fan Engagement</span>
                  </div>
                </TabsTrigger>
                <TabsTrigger value="ad-manager" className="data-[state=active]:bg-background rounded-none py-3">
                  <div className="flex items-center gap-2">
                    <Target className="h-4 w-4" />
                    <span className="hidden md:inline">Ad Manager</span>
                  </div>
                </TabsTrigger>
                <TabsTrigger value="playlist-pitching" className="data-[state=active]:bg-background rounded-none py-3">
                  <div className="flex items-center gap-2">
                    <Music className="h-4 w-4" />
                    <span className="hidden md:inline">Playlist Pitching</span>
                  </div>
                </TabsTrigger>
                <TabsTrigger value="content-generator" className="data-[state=active]:bg-background rounded-none py-3">
                  <div className="flex items-center gap-2">
                    <MessageSquare className="h-4 w-4" />
                    <span className="hidden md:inline">Content Generator</span>
                  </div>
                </TabsTrigger>
                <TabsTrigger value="content-reshaper" className="data-[state=active]:bg-background rounded-none py-3">
                  <div className="flex items-center gap-2">
                    <Share className="h-4 w-4" />
                    <span className="hidden md:inline">Content Reshaper</span>
                  </div>
                </TabsTrigger>
              </TabsList>
              
              <TabsContent value="viral-content" className="mt-0">
                <ViralContentGenerator />
              </TabsContent>
              
              <TabsContent value="auto-promo" className="mt-0">
                <AutoPromoCampaigns />
              </TabsContent>
              
              <TabsContent value="fan-engagement" className="mt-0">
                <FanEngagementManager />
              </TabsContent>
              
              <TabsContent value="ad-manager" className="mt-0">
                <AIAdManager />
              </TabsContent>
              
              <TabsContent value="playlist-pitching" className="mt-0">
                <PlaylistPitching />
              </TabsContent>
              
              <TabsContent value="content-generator" className="mt-0">
                <ContentGenerator />
              </TabsContent>
              
              <TabsContent value="content-reshaper" className="mt-0">
                <ContentReshaper />
              </TabsContent>
            </Tabs>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AIMarketingSuite;
